export enum SearchRequestType {
  postcode = '0',
  manualAddress = '1',
  address = '2'
}

export enum RatesPeriod {
  Future = 'future',
  Current = 'current'
}

export enum FuelType {
  Electricity = 'electricity',
  Gas = 'gas',
  Dual = 'dual'
}
